<template>
  <b-modal id="ts_rate_change_modal" ref="ts_rate_change_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-pound-sign"></i> CHANGE WORKER RATE</h1>
      </div>

      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-12">
        You are changing the rate for:<br>
        <strong>{{ current_assignment.worker.person.first_name }} {{ current_assignment.worker.person.surname }}</strong><br>
        On the following site:<br>
        <strong>{{ current_order_location }}</strong><br>
        Site Position<br>
        <strong>{{ current_assignment.order_job.rel_order_position.job_title }}</strong>
        <hr>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            Current Rate:
          </div>
          <div class="col-6">
            {{ current_assignment.position_rate.pay_amount | currency }} ({{ current_assignment.position_rate.pay_type }})
          </div>
        </div>
        <hr>
      </div>
      <div class="col-12">
        <h4>New Rate</h4>
        <p>Select from the available rates for this workers position on this site.<br>
          If the rate does not exist you can add it as a new rate, simply type in the rate you wish to pay.</p>
      </div>
      <div class="col-12">

        <ValidationObserver ref="changeRateForm" slim>
          <form role="form" @submit.prevent="submit_change_rate" class="row" autocomplete="off">
            <!-- Multiselect to choose from existing rates on order_job -->
            <ValidationProvider v-if="ms_opts.existing_rates.length > 0 && !add_new_rate"
                                rules="required" v-slot="{errors, classes}" name="Pay Rate" tag="div" class="col-8 offset-2 form-group">
              <label class="form-label" for="pay_rate">Pay Rate</label>
              <multiselect v-model="existing_rate" class="requiredField" :class="classes" id="pay_rate" name="pay_rate" placeholder=""
                           :options="ms_opts.existing_rates" :custom-label="existing_rate_label" track-by="id" :show-labels="false">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">£ {{ props.option.pay_amount }}</span>
                    <span class="option__small" style="float: right;">({{ props.option.pay_type }})</span>
                  </div>
                </template>
                <span slot="noResult" class="noResult" slot-scope="props" @click.prevent="ms_add_new_rate(props.search)">ADD NEW RATE</span>
              </multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

            <div class="col-12" v-else>
              <div class="row">
                <!-- If add_rate because the rate does not already exist on the order_job -->
                <!-- Pay Type -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Pay Type" tag="div" class="col-6 form-group">
                  <label class="form-label" for="pay_type">Pay Type</label>
                  <multiselect v-model="new_rate.pay_type" class="requiredField" :class="classes"
                               id="pay_type" name="pay_type" placeholder=""
                               :options="ms_opts.pay_types" label="value" track-by="id"
                               :show-labels="false" @select="check_rate_exists" @input="rate_calc_recruitment_margin(new_rate)"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Pay Amount -->
                <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Pay Amount" tag="div" class="col-6 form-group">
                  <label class="form-label" for="pay_amount">Pay Amount</label>
                  <div class="input-group">
                    <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                    <input type="text" v-model="new_rate.pay_amount" id="pay_amount" name="pay_amount"
                           class="form-input requiredField" :class="[classes, pay_amount_disabled ? 'disabled' : '']" :disabled="pay_amount_disabled"
                           @blur.prevent="check_rate_exists()" @input="rate_calc_recruitment_margin(new_rate)">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-6 offset-6">
              <button type="submit" class="btn orcaBtn" :disabled="saving">
                <span v-if="!saving">Change Rate</span>
                <span v-else-if="saving"><i class="fas fa-spinner fa-spin"></i> Saving Rate Change...</span>
              </button>
            </div>
          </form>
        </ValidationObserver>

      </div>
    </div>

    <!--    TODO --- EMAIL WORKER ?????? -->
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { calculateRate } from 'utils/utils';

export default {
  name: "ts_rate_change",
  components: {Multiselect},
  data() {
    return {
      current_assignment: this.$store.state.client_timesheets.ts_rate_change_current_assignment,
      current_order_location: this.$store.state.client_timesheets.ts_rate_change_current_order_location,
      current_for_work_end_week_date: this.$store.state.client_timesheets.ts_rate_change_current_for_work_end_week_date,
      current_ts_record_id: this.$store.state.client_timesheets.ts_rate_change_current_ts_record_id,

      ms_opts: {
        pay_types: this.$store.state.crm_options.pay_type,
        existing_rates: [],
      },
      add_new_rate: false,
      existing_rate: null,
      new_rate: {
        type: {value: 'Basic', id: 15},
        pay_type: null,
        pay_amount: '',
        admin_fee_type: this.$store.state.client_timesheets.ts_rate_change_current_assignment.position_rate.admin_fee_type,
        admin_fee: this.$store.state.client_timesheets.ts_rate_change_current_assignment.position_rate.admin_fee_amount,
        retention_percentage: '5',
      },
      pay_amount_disabled: false,

      saving: false
    }
  },
  beforeMount() {
    this.new_rate.pay_type = this.ms_opts.pay_types.filter(pt => pt.value ===
        this.$store.state.client_timesheets.ts_rate_change_current_assignment.position_rate.pay_type)[0]

    this.get_order_position_rates();
  },
  methods: {
    hideModal() {
      this.$refs.ts_rate_change_modal.hide();
      this.$store.commit('HIDE_RATE_WORKER_MODAL');
    },

    get_order_position_rates() {
      axios.get(this.crmApiPath + 'order/position_rate/get/' + this.current_assignment.order_job_id).then(rates => {
        this.ms_opts.existing_rates = rates.data.rates
      })
    },

    existing_rate_label({pay_amount, pay_type}) {
      return `£ ${pay_amount}` + ` ` + ` ` + ` ` + `(${pay_type})`
    },

    ms_add_new_rate(search_value) {
      this.new_rate.pay_amount = search_value
      this.add_new_rate = true;
      this.existing_rate = null;
    },
    check_rate_exists() {
      this.$nextTick(() => {
        if (this.new_rate.pay_type !== null) {
          let check = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type === this.new_rate.pay_type.value);
          if (check.length > 0) {
            this.popup_rate_exists(this.new_rate.pay_type.value, this.new_rate.pay_amount)
          }
        }
      })

    },
    popup_rate_exists(pay_type, pay_amount) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Rate Already Exists</div>' +
            '<div class="snotifyToast__body">' +
            'This position on this site already has a £' + pay_amount + ' (' + pay_type + ') rate' + '<br><br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Select Rate', action: (toast) => {
              this.add_new_rate = false;
              this.existing_rate = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type ===
                  this.new_rate.pay_type.value)[0];
              this.$snotify.remove(toast.id);
            }
          },
        ]
      });
    },

    // Calculate margin for recruitment crm / recruitment orders
    rate_calc_recruitment_margin(rate) {
      this.$nextTick(() => {
        let margin = this.this.current_assignment.order_job.rel_order_position.recruitment_margin_perc;
        let orderType = this.current_assignment.order_job.order.order_type;
        rate.admin_fee = calculateRate(rate.pay_amount, this.crmType, orderType, margin, rate.admin_fee);
      });
    },

    submit_change_rate() {
      this.saving = true;
      let t_assigment = null;
      new Promise(resolve => {
        let temp_assignment = {
          worker_id: this.current_assignment.worker_id,
          company_id: this.current_assignment.company_id,
          order_job_id: this.current_assignment.order_job_id,
          position_rate_id: '',
          // Set assigned by values for creating the worker (current crm user)
          assigned_by_type: 'App\\Models\\Users\\User',
          assigned_by_id: this.$store.state.auth.me.id,
          start_date: this.$moment.utc(this.current_for_work_end_week_date).subtract(5, 'days').format('YYYY-MM-DD'),
          end_date: this.current_assignment.order_job.rel_order_position.end_date,
          assigned: true,
          is_gang_leader: this.current_assignment.is_gang_leader,
          gang_leader_id: this.current_assignment.gang_leader_id,
          // Set log values for creating the worker (current crm user)
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        }
        // if an existing rate is chosen set the position_rate_id on the assignment object
        if (this.existing_rate !== null) {
          temp_assignment.position_rate_id = this.existing_rate.id
          t_assigment = temp_assignment
          resolve();
        }
        // create new rate and set position_rate_id on the assignment object
        else {
          let position_rate = {
            order_job_id: this.current_assignment.order_job_id,
            rate_type: this.new_rate.type.value,
            pay_type: this.new_rate.pay_type.value,
            pay_amount: this.new_rate.pay_amount,
            admin_fee_type: this.new_rate.admin_fee_type,
            admin_fee_amount: this.new_rate.admin_fee,
            retention_percentage: this.new_rate.retention_percentage,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          };
          axios.post(this.crmApiPath + 'order/position_rate', position_rate).then(position_rate_id => {
            temp_assignment.position_rate_id = position_rate_id.data
            t_assigment = temp_assignment
            resolve();
          });
        }
      }).then(() => {
          // update assignment
          axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + this.current_assignment.id, t_assigment).then(() => {

              // hide the modal
              this.hideModal();

              // reload location
              this.$emit('reload-location-details');
          });
      })
    }
  },
  watch: {
    'new_rate.pay_type'(type) {
      if (type !== null) {
        // Price - pay type, set pay amount to 1 and disable input
        if (this.new_rate.pay_type.id === 24) {
          this.new_rate.pay_amount = 1;
          this.pay_amount_disabled = true;
        }
        // for all other pay types, enable pay_amount input
        else {
          this.new_rate.pay_amount = '';
          this.pay_amount_disabled = false;
        }
      }
    }
  }
}
</script>

<style lang="scss">
#ts_rate_change_modal {
  .multiselect__option {
    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      background: $bc_1;
      color:      $white;
    }
  }

  .noResult {
    margin:      -10px -30px -10px -15px;
    padding:     10px 15px;
    height:      38px;
    line-height: inherit;
    display:     block;
    width:       100%;

    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      color:      $white;
      background: $bc_1;
    }
  }
}
</style>
